class MetaAPI {

    static titleElement;
    static descriptionElement;

    titlePrefix = '';
    constructor({titlePrefix}){
        this.titlePrefix = titlePrefix;
    }

    _getTitle(){

        if(!MetaAPI.titleElement){

            MetaAPI.titleElement = document.querySelector('title');

        }

        return MetaAPI.titleElement;

    }
    _getDescription(){


        if(!MetaAPI.descriptionElement){

            MetaAPI.descriptionElement = document.querySelector('meta[name=description]');

        }

        return MetaAPI.descriptionElement;

    }

    setTitle(title){

        this._getTitle().innerText = this.titlePrefix + title;

    }

    setDescription(description){

        this._getDescription().setAttribute('content', description);

    }

    set({title, description}){

        title && this.setTitle(title);
        description && this.setDescription(description);

    }

}

export default class MetaPlugin {

    static install(Vue, options = {}) {

        options;
        Vue.$Meta = new MetaAPI(options);

        Vue.prototype.$Meta = Vue.$Meta;

    }

}
